<div style="display: flex; flex-direction: row; justify-content: space-between">
    <div class="purchase-order-details full-width-container1"
        style="display: flex; flex-direction: column; overflow-x: hidden">
        <div class="col-xl-10 col-lg-9 col-9 p-0 card-body-fixheight z-index-4" style="width: 100%">
            <mat-card class="p-0" style="margin: 0 0.5rem">
                <mat-card-content #pdfContent class="ship-fscoll hgt ship-pr-sec">
                    <div class="purchase-order-details-title">

                        <div style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin: 10px 0;
                  ">
                           

                            <div 
                            class="alert alert-info d-flex align-items-center justify-content-between"
                            role="alert" style="border-radius: 8px; margin-bottom: 10px;margin: 15px; width: 100%;">

                            <!-- Left: Icon + Heading + Description -->
                            <div class="d-flex align-items-center">
                                <mat-icon class="me-3">check_circle</mat-icon>
                                <div>


                                    <h1 class="mb-1 fw-bold"> Order Successfully Delivered & Confirmed</h1>
                                    <p class="mb-0 small">Invoice : {{  dispatchFormGroup.value.invoiceRefNumber || 'N/A' }}</p>
                                    <!-- <p class="mb-0 small">Confirmed on : {{  orderReceiptForm.value.submittedOn || 'N/A' }}, received by {{  orderReceiptForm.value.buyerName || 'N/A' }}</p> -->
                                    <p class="mb-0 small">Confirmed on : {{  orderReceiptForm.value.submittedOn || 'N/A' }}, received by {{  orderReceiptForm.value.receivedBy || 'N/A' }}</p>
                                  </div>
                            </div>

                        </div>

                       
                          

                            <!-- Action Buttons -->
                            <!-- <div style="display: flex; gap: 10px">
                    <button
                      mat-stroked-button
                      color="primary"
                      style="
                        font-size: 18px;
                        padding-left: 32px;
                        padding-right: 32px;
                        padding-top: 24px;
                        padding-bottom: 24px;
                        color: #42a190;
                        background-color: #d9e0e4;
                      "
                      (click)="uploadPOD()"
                    >
                      Upload POD
                      <mat-icon style="color: #42a190">upload</mat-icon>
                    </button>
    
                    <button
                      mat-stroked-button
                      color="primary"
                      style="
                        font-size: 18px;
                        padding-left: 32px;
                        padding-right: 32px;
                        padding-top: 24px;
                        padding-bottom: 24px;
                        color: #42a190;
                        background-color: #d9e0e4;
                      "
                      [matMenuTriggerFor]="downloadMenu"
                    >
                      Packaging Documents
                      <mat-icon style="color: #42a190">arrow_drop_down</mat-icon>
                    </button>
    
                    <mat-menu #downloadMenu="matMenu">
                      <button
                        mat-menu-item
                        (click)="onSelectDownload('Commercial Invoice')"
                      >
                        <mat-icon>download</mat-icon>
                        <span>Download Commercial Invoice</span>
                      </button>
                      <button
                        mat-menu-item
                        (click)="onSelectDownload('Packaging List')"
                      >
                        <mat-icon>download</mat-icon>
                        <span>Download Packing Slip</span>
                      </button>
                      <button
                        mat-menu-item
                        (click)="onSelectDownload('Delivery Note')"
                      >
                        <mat-icon>download</mat-icon>
                        <span>Download Delivery Note</span>
                      </button>
                    </mat-menu>
                  </div> -->
                        </div>
                    </div>

                    <div style="display: flex;">
                        <div class="header-form-header" style="flex: 1;padding: 20px;">

                            <h3 style="font-weight: bold; display: flex; align-items: center;">
                                <button mat-icon-button><mat-icon>approval</mat-icon></button>
                                Delivery Note With Stamp
                            </h3>

                            <div class="file-name-box">
                                {{
                                    getDeliveryDocumentsAttachment().length > 1
                                ? getDeliveryDocumentsAttachment().length + " files attached"
                                : getDeliveryDocumentsAttachment().length === 1
                                ? "1 file attached"
                                : "No file attached"
                                }}

    
                                <button *ngIf="getDeliveryDocumentsAttachment().length > 0 "
                                    mat-icon-button matTooltipClass="mat-tooltip-custom"
                                    matTooltip="View" matTooltipPosition="below"
                                    (click)="togglePreview(true, 'deliveryNoteDocument')">
                                    <mat-icon>visibility</mat-icon>
                                </button>
                            </div>
                        </div>
    
                        <div class="header-form-header" style="flex: 1;padding: 20px;">
                            <h3 style="font-weight: bold; display: flex; align-items: center;"><button
                                mat-icon-button><mat-icon>article</mat-icon></button>Additional
                            Documents</h3>
                            <div class="file-name-box">
                                {{
                                    getReceiptAdditionalAttachment().length > 1
                                ? getReceiptAdditionalAttachment().length + " files attached"
                                : getReceiptAdditionalAttachment().length === 1
                                ? "1 file attached"
                                : "No file attached"
                                }}
    
                                <button *ngIf="getReceiptAdditionalAttachment().length > 0 "
                                    mat-icon-button matTooltipClass="mat-tooltip-custom"
                                    matTooltip="View" matTooltipPosition="below"
                                    (click)="togglePreview(true, 'additionalDocument')">
                                    <mat-icon>visibility</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                    

                    <div style="border: 1px solid black;margin: 20px; padding: 50px;" class="header-form-header">
                        <span style="
                                padding-left: 16px;
                                padding-top: 16px;
                                font-weight: bold;
                                display: flex;
                                justify-content: space-between;
                                padding-right: 20px;
                                background: #C8E6C9;
                              " (click)="toggleVisibility('form1')">

                            <div style="display: flex;justify-content: center;align-items: center;font-size: larger;">
                                <button mat-icon-button><mat-icon>inventory_2</mat-icon></button>
                                Order Summary
                            </div>

                            <mat-icon>{{
                                isForm1Expand ? "minimize" : "add"
                                }}</mat-icon>
                        </span>
                        <div style="width: 100%" *ngIf="isForm1Expand">
                            <form [formGroup]="dispatchFormGroup">
                                <div>
                                    <!-- Order Details -->
                                    <div class="header-form-header">
                                        <span style="
                                padding-left: 16px;
                                padding-top: 16px;
                                margin-bottom: 32px;
                                font-weight: bold;
                                display: flex;
                                justify-content: space-between;
                                padding-right: 20px;
                              " (click)="toggleVisibility('form2')">
                                            Order Details
                                            <mat-icon>{{
                                                isForm2Expand ? "minimize" : "add"
                                                }}</mat-icon>
                                        </span>

                                        <div *ngIf="isForm2Expand" class="three-column-flex">
                                            <div class="form-item-row-header">
                                                <mat-form-field class="full-width" color="accent">
                                                    <mat-label>RFQ Ref No</mat-label>
                                                    <input matInput formControlName="rfqRefNumber" readonly />
                                                </mat-form-field>
                                            </div>

                                            <div class="form-item-row-header">
                                                <mat-form-field class="full-width" color="accent">
                                                    <mat-label>Quote Ref No</mat-label>
                                                    <input matInput formControlName="quoteRefNumber" readonly />
                                                </mat-form-field>
                                            </div>

                                            <div class="form-item-row-header">
                                                <mat-form-field class="full-width" color="accent">
                                                    <mat-label>PO Number</mat-label>
                                                    <input matInput formControlName="poRefNumber" readonly />
                                                </mat-form-field>
                                            </div>

                                            <div class="form-item-row-header">
                                                <mat-form-field class="full-width" color="accent">
                                                    <mat-label>Supplier</mat-label>
                                                    <input matInput formControlName="supplierName" readonly />
                                                </mat-form-field>
                                            </div>

                                            <div class="form-item-row-header">
                                                <mat-form-field class="full-width" color="accent">
                                                    <mat-label>Invoice Number</mat-label>
                                                    <input matInput formControlName="invoiceRefNumber" readonly />
                                                </mat-form-field>
                                            </div>

                                            <div class="form-item-row-header">
                                                <mat-form-field class="full-width" color="accent">
                                                    <mat-label>Supplier Dispatch Ref</mat-label>
                                                    <input matInput formControlName="supplierDispatchRefNumber" />
                                                </mat-form-field>
                                            </div>

                                            <div class="form-item-row-header">
                                                <mat-form-field class="full-width" color="accent">
                                                    <mat-label>Incoterms</mat-label>

                                                    <input matInput formControlName="incoterms" />
                                                    
                                                </mat-form-field>
                                            </div>

                                            <div class="form-item-row-header">
                                                <mat-form-field class="full-width" color="accent">
                                                    <mat-label>Dispatch Date</mat-label>

                                                    <input matInput name="dispatchDate" formControlName="dispatchDate"
                                                        [matDatepicker]="dispatchDateDatepicker" [min]="minDate" />

                                                    <mat-datepicker-toggle matSuffix [for]="dispatchDateDatepicker"
                                                        [disabled]="false"></mat-datepicker-toggle>

                                                    <mat-datepicker #dispatchDateDatepicker></mat-datepicker>

                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Freight Details -->
                                    <div class="header-form-header">
                                        <span style="
                                padding-left: 16px;
                                padding-top: 16px;
                                margin-bottom: 32px;
                                font-weight: bold;
                                display: flex;
                                justify-content: space-between;
                                padding-right: 20px;
                              " (click)="toggleVisibility('form3')">
                                            Freight Forwarder Details
                                            <mat-icon>{{
                                                isForm3Expand ? "minimize" : "add"
                                                }}</mat-icon>
                                        </span>

                                        <div *ngIf="isForm3Expand" class="three-column-flex">
                                            <div class="form-item-row-header">
                                                <mat-form-field class="full-width" color="accent">
                                                    <mat-label>Freight Forwarder</mat-label>
                                                    <input matInput formControlName="freightForwarder" readonly />
                                                </mat-form-field>
                                            </div>

                                            <div class="form-item-row-header">


                                                <mat-form-field class="full-width" color="accent">
                                                    <mat-label>Mode of Transport</mat-label>
                                                    <input matInput formControlName="modeOfTransport" />
                                                    
                                                </mat-form-field>
                                            </div>

                                            <div class="form-item-row-header">
                                                <mat-form-field class="full-width" color="accent">
                                                    <mat-label>AWB Number</mat-label>
                                                    <input matInput formControlName="awbNumber" />
                                                </mat-form-field>
                                            </div>

                                            <div class="form-item-row-header">
                                                <mat-form-field class="full-width" color="accent">
                                                    <mat-label>Tracking Link</mat-label>
                                                    <input
                                                        matInput
                                                        class="tracking-link-input"
                                                        formControlName="trackingLink"
                                                        [readonly]="isBuyer"
                                                        (click)="openTrackingLink()"
                                                    />
                                                </mat-form-field>
                                            </div>


                                        </div>
                                    </div>

                                    <div class="header-form-header">
                                        <span style="
                                padding-left: 16px;
                                padding-top: 16px;
                                margin-bottom: 32px;
                                font-weight: bold;
                                display: flex;
                                justify-content: space-between;
                                padding-right: 20px;
                              " (click)="toggleVisibility('form2')">
                                            Requirement Details
                                            <mat-icon>{{
                                                isForm2Expand ? "minimize" : "add"
                                                }}</mat-icon>
                                        </span>

                                        <div *ngIf="isForm2Expand" class="two-column-flex">
                                            <div *ngFor="let req of selectedRequirements"
                                                class="alert alert-info d-flex align-items-center justify-content-between"
                                                role="alert" style="border-radius: 8px; margin-bottom: 10px;">

                                                <!-- Left: Icon + Heading + Description -->
                                                <div class="d-flex align-items-center">
                                                    <mat-icon class="me-3">{{ req.iconName }}</mat-icon>
                                                    <div>
                                                        <h6 class="mb-1 fw-bold">{{ req.requirementName }}</h6>
                                                        <p class="mb-0 small">{{ req.requirementDescription }}</p>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>




                                    <div class="header-form-header">
                                        <span style="
                                  padding-left: 16px;
                                  padding-top: 16px;
                                  margin-bottom: 32px;
                                  font-weight: bold;
                                  display: flex;
                                  justify-content: space-between;
                                  padding-right: 20px;
                                ">
                                            Dispatch Documents
                                        </span>
                                        <!-- Document upload -->
                                        <div style="padding: 0 16px 16px 16px;  display: flex;gap: 30px;">

                                            <!-- Proof of Pickup Section -->

                                            <div style="flex:1;">
                                                <h3 style="font-weight: bold;">Proof of Pickup</h3>
                                                <div class="file-name-box">
                                                    {{
                                                    getProofOfPickupAttachment().length > 1
                                                    ? getProofOfPickupAttachment().length + " files attached"
                                                    : getProofOfPickupAttachment().length === 1
                                                    ? "1 file attached"
                                                    : "No file attached"
                                                    }}

                                                    <button *ngIf="getProofOfPickupAttachment().length > 0 "
                                                        mat-icon-button matTooltipClass="mat-tooltip-custom"
                                                        matTooltip="View" matTooltipPosition="below"
                                                        (click)="togglePreview(true, 'proofOfPickup')">
                                                        <mat-icon>visibility</mat-icon>
                                                    </button>
                                                </div>
                                            </div>

                                            <div style="flex:1;">
                                                <h3 style="font-weight: bold;">

                                                    Additional Documents</h3>
                                                <div class="file-name-box">
                                                    {{
                                                    getAdditionalAttachment().length > 1
                                                    ? getAdditionalAttachment().length + " files attached"
                                                    : getAdditionalAttachment().length === 1
                                                    ? "1 file attached"
                                                    : "No file attached"
                                                    }}

                                                    <button *ngIf="getAdditionalAttachment().length > 0 "
                                                        mat-icon-button matTooltipClass="mat-tooltip-custom"
                                                        matTooltip="View" matTooltipPosition="below"
                                                        (click)="togglePreview(true, 'additionalDocument')">
                                                        <mat-icon>visibility</mat-icon>
                                                    </button>
                                                </div>
                                            </div>



                                        </div>
                                    </div>


                                </div>
                            </form>
                        </div>
                    </div>


                    <div style="width: 100%">
                        <form [formGroup]="orderReceiptForm">
                            <div>
                                <!-- Receipt Details -->
                                <div class="header-form-header">
                                    <span style="
                            padding-left: 16px;
                            padding-top: 16px;
                            margin-bottom: 32px;
                            font-weight: bold;
                            display: flex;
                            justify-content: space-between;
                            padding-right: 20px;
                          " (click)="toggleVisibility('form1')">
                                        Receipt Details

                                    </span>


                                    <div class="form-item-row-header">
                                        <mat-form-field class="full-width" color="accent">
                                            <mat-label>Received Date</mat-label>

                                            <input matInput name="receivedDate" formControlName="receivedDate"
                                                [matDatepicker]="receivedDateDatepicker" [min]="minDate" />

                                            <mat-datepicker-toggle matSuffix [for]="receivedDateDatepicker"
                                                [disabled]="false"></mat-datepicker-toggle>

                                            <mat-datepicker #receivedDateDatepicker></mat-datepicker>

                                        </mat-form-field>
                                    </div>


                                    <div class="form-item-row-header">
                                        <mat-form-field class="full-width" color="accent">
                                            <mat-label>Received By</mat-label>
                                            <!-- <input matInput formControlName="buyerName" readonly /> -->
                                            <input matInput formControlName="receivedBy" readonly />
                                        </mat-form-field>
                                    </div>





                                </div>

                                <!-- condition and remarks & discrepency details  -->
                                <div class="header-form-header">
                                    <span style="
                            padding-left: 16px;
                            padding-top: 16px;
                            margin-bottom: 32px;
                            font-weight: bold;
                            display: flex;
                            justify-content: space-between;
                            padding-right: 20px;
                          " (click)="toggleVisibility('form2')">
                                        Condition and remarks & discrepency details

                                    </span>


                                    <div style="padding: 0 16px 16px 16px">
                                        <mat-form-field class="full-width" color="accent" appearance="fill">
                                            <mat-label>Remarks</mat-label>
                                            <textarea matInput formControlName="remarks"
                                                placeholder="Describe the condiition of received items. if there are any issues, damages, or discrepencies, please provide detailed information here.."
                                                rows="3"></textarea>
                                        </mat-form-field>

                                        <!-- Removed log button by request -->
                                    </div>

                                </div>


                                <div class="header-form-header" *ngIf="!isFeedbackSubmitted">
                                    <span style="
                            padding-left: 16px;
                            padding-top: 16px;
                            margin-bottom: 32px;
                            font-weight: bold;
                            display: flex;
                            justify-content: space-between;
                            padding-right: 20px;
                          " >
                                        Buyer Feedbacks

                                    </span>


                                    <div style="padding: 0 16px 16px 16px">
                                        <div class="alert alert-danger">No feedbacks Submitted</div>
                                        
                                    </div>

                                </div>


                                <div class="feedback-preview-container" *ngIf="isFeedbackSubmitted && isBuyer">

                                    <!-- Green header -->
                                    <div class="feedback-preview-header">
                                        <div class="header-content">
                                          <h3>Your Feedback</h3>
                                          <p class="submitted-date">Submitted on: 
                                            <strong>{{ feedbackData?.submittedOn | date:'mediumDate' }}</strong>
                                          </p>
                                        </div>
                                      </div>
                                    
                                      <!-- Rating section in yellow -->
                                      <div class="alert alert-warning rating-preview" role="alert">
                                        <h4 class="mb-2" style="display: flex; justify-content: center;">Your overall Rating</h4>
                                        <div class="star-rating readonly">
                                          <span
                                            *ngFor="let star of stars; let i = index"
                                            class="star"
                                            [class.filled]="i < feedbackData?.ratings"
                                          >
                                            ★
                                          </span>
                                          <span class="rating-value">{{ feedbackData?.ratings }}/5</span>
                                        </div>
                                      </div>
                                    
                                      <!-- Recommendation section -->
                                      <div class="recommend-preview">
                                        <p>Would you recommend this supplier?</p>
                                        <button
                                          mat-mini-fab
                                          color="{{ feedbackData?.wouldYouRecommend ? 'primary' : 'warn' }}"
                                          disabled
                                          class="recommend-btn"
                                        >
                                          <mat-icon>
                                            {{ feedbackData?.wouldYouRecommend ? 'thumb_up' : 'thumb_down' }}
                                          </mat-icon>
                                        </button>
                                        <span class="recommend-text">
                                          {{ feedbackData?.wouldYouRecommend ? 'Yes, I recommend' : 'No, I wouldn’t recommend' }}
                                        </span>
                                      </div>
                                    
                                      <!-- Comments -->
                                      <div *ngIf="feedbackData?.comments" class="comments-preview">
                                        <h4 style="display: flex;"><mat-icon>comment</mat-icon>Your Comments</h4>
                                        <p>{{ feedbackData.comments }}</p>
                                      </div>

                                      <div 
                                      class="alert alert-info d-flex align-items-center justify-content-between"
                                      role="alert" style="border-radius: 8px; margin-bottom: 10px;margin: 15px; width: 100%;">
          
                                      <!-- Left: Icon + Heading + Description -->
                                      <div class="d-flex align-items-center">
                                     
                                        <mat-icon class="me-3">check_circle</mat-icon>
                                        <div>
        
        
                                            <h1 class="mb-1 fw-bold"> Your feedback has been shared with {{feedbackData?.supplierCompanyName}}</h1>
                                            <p >Your review helps improve service quality for all customers in the maritime industry</p>
                                        </div>
                                    </div>


                                      
                                  
                                  </div>
                                </div>

                                <div class="feedback-preview-container" *ngIf="isFeedbackSubmitted && !isBuyer">

                                    <!-- Green header -->
                                    <div class="feedback-preview-header">
                                        <div class="header-content" style="display: flex;flex-direction: column;align-items: start;">
                                          <h3>Customer Feedback Received</h3>
                                          <p>Submitted By {{feedbackData?.buyerCompanyName}}, on {{ feedbackData?.submittedOn | date:'mediumDate' }}</p>
                                          
                                        </div>
                                      </div>
                                    
                                      <!-- Rating section in yellow -->
                                      <div class="alert alert-warning rating-preview" role="alert">
                                        <h4 class="mb-2" style="display: flex; justify-content: center;">Overall Rating</h4>
                                        <div class="star-rating readonly">
                                          <span
                                            *ngFor="let star of stars; let i = index"
                                            class="star"
                                            [class.filled]="i < feedbackData?.ratings"
                                          >
                                            ★
                                          </span>
                                          <span class="rating-value">{{ feedbackData?.ratings }}/5</span>
                                        </div>
                                      </div>
                                    
                                      <!-- Recommendation section -->
                                      <div class="recommend-preview">
                                        <p>Would you recommend?</p>
                                        <button
                                          mat-mini-fab
                                          color="{{ feedbackData?.wouldYouRecommend ? 'primary' : 'warn' }}"
                                          disabled
                                          class="recommend-btn"
                                        >
                                          <mat-icon>
                                            {{ feedbackData?.wouldYouRecommend ? 'thumb_up' : 'thumb_down' }}
                                          </mat-icon>
                                        </button>
                                        <span class="recommend-text">
                                          {{ feedbackData?.wouldYouRecommend ? 'Yes, I recommend' : 'No, I wouldn’t recommend' }}
                                        </span>
                                      </div>
                                    
                                      <!-- Comments -->
                                      <div *ngIf="feedbackData?.comments" class="comments-preview">
                                        <h4 style="display: flex;"><mat-icon>comment</mat-icon>Customer Comments</h4>
                                        <p>{{ feedbackData.comments }}</p>
                                      </div>

                                      
                                </div>

                               


                               

                                <div style="
                  width: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin-top: 20px;
                ">
                                    <button mat-raised-button color="warn" (click)="closeCreateDispatchPage()" style="
                    font-size: 18px;
                    padding-left: 32px;
                    padding-right: 32px;
                    padding-top: 24px;
                    padding-bottom: 24px;
                    background-color: #d11;
                    margin-right: 5px;
                  ">
                                        Close
                                    </button>
                                    <button mat-raised-button color="primary" (click)="openFeedback()" 
                                    *ngIf="isBuyer"
                                     style="
                                        font-size: 18px;
                                        padding-left: 23px;
                                        padding-right: 23px;
                                        padding-top: 24px;
                                        padding-bottom: 24px;
                                        background-color: #1f7e3f;
                                        margin-left: 5px;
                    ">
                                       
                                       {{ isFeedbackSubmitted ? 'Edit Feedback' : 'Add Feedback' }}
                                    </button>

                                    <button mat-raised-button color="primary" (click)="openFeedback()" 
                                    *ngIf="!isBuyer && isFeedbackSubmitted"
                                     style="
                                        font-size: 18px;
                                        padding-left: 23px;
                                        padding-right: 23px;
                                        padding-top: 24px;
                                        padding-bottom: 24px;
                                        background-color: #1f7e3f;
                                        margin-left: 5px;
                    ">
                                       
                                       View Full Feedback Details
                                    </button>
                                </div>


                            </div>
                        </form>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>

<!-- <div *ngIf="showNotification">
    <div class="notification-overlay" (click)="dismissNotification()"></div>
    <div class="notification-popup show" [ngClass]="{
          'info-notification': notificationType === 'info',
          'error-notification': notificationType === 'error'
        }">
        <div class="notification-content">
            <h3 style="margin-top: 0; margin-bottom: 12px">{{ notificationTitle }}</h3>
            <div class="notification-message" [innerHTML]="notificationMessage"></div>
            <button type="button" class="btn-ok" (click)="dismissNotification()">
                OK
            </button>
        </div>
    </div>
</div> -->

<div *ngIf="showSuccessMessage">
    <div class="notification-overlay" (click)="dismissNotification()"></div>
  
    <div class="notification-popup show success-notification" style="width: 35%;">
      <!-- Top green section -->
      <div class="notification-header">
        <div class="icon-text">
          <mat-icon>check_circle</mat-icon>
          
          <h1>Order Confirmed</h1>
        </div>
        <p class="notification-message">Thank you for confirming receipt</p>
      </div>
  
      <!-- Bottom white section -->
      <div class="notification-footer">
        <p class="experience-text">Share your experience ?</p>
        <p>Would you like to submit feedback for this order ?</p>
        <div  class="alert alert-info "
        role="alert" style="border-radius: 8px; margin-bottom: 10px;">
        <p>Order : {{  dispatchFormGroup.value.poRefNumber || 'N/A' }}</p> <br>
        <p>Supplier : {{  dispatchFormGroup.value.supplierName || 'N/A' }}</p>
        </div>
        <div class="button-group">
          <button type="button" class="btn-primary" (click)="openFeedback()"><mat-icon>star_border</mat-icon>Yes, Submit Feedback</button>
          <button type="button" class="btn-secondary" (click)="closeSuccessPopUp()">Skip for Now</button>
        </div>
      </div>
    </div>
  </div>




  <div *ngIf="showFeedbackSection && isBuyer"> 
    <!-- <div class="notification-overlay" (click)="dismissFeedback()"></div> -->
  
    <form [formGroup]="feedbackForm" class="feedback-popup show" (ngSubmit)="submitFeedback()">
        <!-- Header -->
        <div class="feedback-header">
          <div class="header-content">
            <h3>Quick Feedback</h3>
            <button type="button" class="close-btn" (click)="dismissFeedback()">✕</button>
          </div>
          <p>Share your experience with this supplier</p>
        </div>

        <div  class="alert alert-info "
        role="alert" style="border-radius: 8px; margin-bottom: 10px; margin: 20px;">
        <p>Order : {{  dispatchFormGroup.value.poRefNumber || 'N/A' }}</p> <br>
        <p>Supplier : {{  dispatchFormGroup.value.supplierName || 'N/A' }}</p>
        </div>
    
        <!-- Rating Section -->
        <div class="feedback-section">
          <h4>How would you rate this supplier?</h4>
          <div class="star-rating">
            <span
              *ngFor="let star of stars; let i = index"
              class="star"
              [class.filled]="i < feedbackForm.get('ratings')?.value"
              (click)="setRating(i + 1)"
            >
              ★
            </span>
          </div>
          <div class="error-message" *ngIf="feedbackForm.get('rating')?.touched && feedbackForm.get('rating')?.invalid">
            Please select a rating.
          </div>
        </div>
    
        <!-- Recommendation -->
        <div class="feedback-section">
          <h4>Would you recommend this supplier?</h4>
          <div class="button-group">
            <button
              type="button"
              class="btn-choice"
              [class.selected]="feedbackForm.get('wouldYouRecommend')?.value === true"
              (click)="setRecommendation(true)"
            >
            <mat-icon>thumb_up</mat-icon>
              Yes
            </button>
            <button
              type="button"
              class="btn-choice"
              [class.selected]="feedbackForm.get('wouldYouRecommend')?.value === false"
              (click)="setRecommendation(false)"
            >
            <mat-icon>thumb_down</mat-icon>
              No
            </button>
          </div>
          <div class="error-message" *ngIf="feedbackForm.get('wouldYouRecommend')?.touched && feedbackForm.get('wouldYouRecommend')?.invalid">
            Please select an option.
          </div>
        </div>
    
        <!-- Comments -->
        <div class="feedback-section">
          <h4>Your comments</h4>
          <textarea
            formControlName="comments"
            rows="4"
            placeholder="Tell us about your experience..."
          ></textarea>
          <div class="error-message" *ngIf="feedbackForm.get('comments')?.errors?.['maxlength']">
            Comment cannot exceed 500 characters.
          </div>
        </div>
    
        <!-- Footer -->
        <div class="feedback-footer">
          <button type="submit" class="btn-submit"> <mat-icon>send</mat-icon>Submit Feedback</button>
          <button type="button" class="btn-cancel" (click)="dismissFeedback()">Cancel</button>
        </div>
      </form>
  </div>

  <div *ngIf="showFeedbackSection && !isBuyer"> 
    <!-- <div class="notification-overlay" (click)="dismissFeedback()"></div> -->
  
    <form [formGroup]="feedbackForm" class="feedback-popup show" (ngSubmit)="submitFeedback()">
        <!-- Header -->
        <div class="feedback-header">
          <div class="header-content">
            <h3>Customer Feedback Received</h3>
            <button type="button" class="close-btn" (click)="dismissFeedback()">✕</button>
          </div>
          <p>Order : {{  dispatchFormGroup.value.poRefNumber || 'N/A' }}</p>
        </div>

        <div  class="alert alert-info d-flex align-items-start justify-content-between"
        role="alert" style="border-radius: 8px; margin-bottom: 10px; margin: 20px; display: flex;flex-direction: column;">
        
        <!-- <p>Buyer : {{ feedbackData?.buyerCompanyName || 'N/A' }}</p> -->
         <p>Buyer : {{ feedbackData?.receivedBy || 'N/A' }}</p>
        <p>Submitted On : {{ feedbackData?.submittedOn | date:'mediumDate' }}</p> 
        <p>Order Date : {{ feedbackData?.submittedOn | date:'mediumDate' }}</p>
        </div>
    
        <!-- Rating Section -->
        <div class="feedback-section">
          <div class="star-rating">
            <span
              *ngFor="let star of stars; let i = index"
              class="star"
              [class.filled]="i < feedbackForm.get('ratings')?.value"
             
            >
              ★
            </span>
          </div>
          
        </div>
    
        <div class="recommend-preview">
            <p>Would you recommend?</p>
            <button
              mat-mini-fab
              color="{{ feedbackData?.wouldYouRecommend ? 'primary' : 'warn' }}"
              disabled
              class="recommend-btn"
            >
              <mat-icon>
                {{ feedbackData?.wouldYouRecommend ? 'thumb_up' : 'thumb_down' }}
              </mat-icon>
            </button>
            <span class="recommend-text">
              {{ feedbackData?.wouldYouRecommend ? 'Yes, I recommend' : 'No, I wouldn’t recommend' }}
            </span>
          </div>
        
          <!-- Comments -->
          <div *ngIf="feedbackData?.comments" class="comments-preview">
            <h4 style="display: flex;"><mat-icon>comment</mat-icon>Customer Comments</h4>
            <p>{{ feedbackData.comments }}</p>
          </div>
    
        
      </form>
  </div>
  
  

<!--   
  <div class="sidebar" style="overflow: auto" *ngIf="showAddDispatchRequirement">
    <div class="sidebar-title" style="justify-content: space-between; padding: 15px 15px">
      <div class="sidebar-title-text">Add New Requirements</div>
      <div style="
        display: flex;
        justify-content: right;
        width: 50%;
        gap: 10px;
      ">
  
        <span style="float: right" class="pointer header-close-btn" matTooltipClass="mat-tooltip-custom"
          matTooltip="Close" matTooltipPosition="below" (click)="toggleSidebar(false, 'requirementForm')">
          <mat-icon style="color: white">close</mat-icon>
        </span>
      </div>
    </div>
  
    <div class="sidebar-content">
      <form [formGroup]="requirementsFormGroup">
  
  
        <mat-form-field class="full-width" color="accent">
          <mat-label>Requirement Type</mat-label>
          <mat-select matInput formControlName="requirementType" (selectionChange)="onTypeChange($event)">
            <mat-option *ngFor="let item of typeData" [value]="item.name">
              {{ item.label }}</mat-option>
          </mat-select>
        </mat-form-field>
  
        <ng-container *ngIf="requirementsFormGroup.get('requirementType')?.value === 'other'">
          <mat-form-field class="full-width" color="accent">
            <mat-label>Requirement Type</mat-label>
            <input matInput formControlName="typeName" />
          </mat-form-field>
        </ng-container>
  
  
  
  
        <mat-form-field class="full-width" color="accent">
          <mat-label>Requirement Name</mat-label>
          <input matInput formControlName="requirementName" />
        </mat-form-field>
  
        <mat-form-field class="full-width" color="accent">
          <mat-label>Requirement Description</mat-label>
          <input matInput formControlName="requirementDescription" />
        </mat-form-field>
  
  
      </form>
  
      <div class="button-container">
        <button type="button" class="save-button" (click)="createDispatchRequirement()">
          <mat-icon>save</mat-icon>
        </button>
        <button type="button" class="close-button" (click)="toggleSidebar(false, 'requirementForm')">
          <mat-icon>cancel</mat-icon>
        </button>
      </div>
  
    </div>
  </div> -->


<div class="carousel-container" *ngIf="previewSection">
    <div class="carousel-close-button" style="display: flex; flex-direction: row; gap: 10px">
        <!-- <button class="image-download-button" *ngIf="buyerAttachmentUrl.length>0"   (click)="downloadDocument(buyerAttachmentUrl[currentIndex])">
            <mat-icon style="font-size:20px">download</mat-icon>
    </button> -->
        <button *ngIf="previewDocs.length > 0" class="download-button" (click)="downloadDocFile(previewDocs[currentIndex].dataUrl)">
            <mat-icon>download</mat-icon>
        </button>
        <button class="image-close-button" (click)="togglePreview(false, '')">
            <mat-icon style="font-size: 20px">cancel</mat-icon>
        </button>
    </div>
    <div class="carousel">
        <button class="carousel-control prev" (click)="prevSlide()">
            &#10094;
        </button>

        <div class="carousel-image-container">

            <div class="headerattachmentcarouselimageContainerInner" *ngIf="isPdf(previewDocs[currentIndex]?.dataUrl)">
                <pdf-viewer [src]="previewDocs[currentIndex]?.dataUrl" [render-text]="false" [page]="1"
                    [show-all]="true" [original-size]="false" class="content">
                </pdf-viewer>
            </div>
            <div class="headerattachmentimage-container-inner" *ngIf="!isPdf(previewDocs[currentIndex]?.dataUrl)">
                <img [src]="previewDocs[currentIndex]?.dataUrl" [alt]="'dispatch-image'" class="carousel-image" />
            </div>
        </div>

        <button class="carousel-control next" (click)="nextSlide()">
            &#10095;
        </button>
    </div>
</div>
